import React, { ReactNode } from 'react';
import {
  OrganisationInstitutionalIdDTO,
  PersonInstitutionalIdDTO,
  ProjectInstitutionalIdDTO,
} from '../../../../api/core/models';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { IntlShape, useIntl } from 'react-intl';
import { getDefaultInstitutionalId } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { getVocabularyOptions } from '../../../../Vocabulary/util';
import { InputGroup } from '../layout/InputGroup';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { Panel } from '../layout/Panel';

export type InstitutionalId = ProjectInstitutionalIdDTO | OrganisationInstitutionalIdDTO | PersonInstitutionalIdDTO;

interface InstitutionalIdsProps<T> {
  checkPermission: CheckPermissionFunction;
  institutionalIds: T[];
  onChange: (subject: T[]) => void;
  pubtypeGroup?: string;
  typesList: string;
  validation?: ValidationResult;
  title: string;
  autoFocus: boolean;
}

export function InstitutionalIds<T>(props: InstitutionalIdsProps<T>): ReactNode {
  const intl: IntlShape = useIntl();
  return (
    <Panel title={props.title} toggleable={true}>
      <MultiInputControls<InstitutionalId>
        canEdit={props.checkPermission().canWrite}
        lines={props.institutionalIds}
        addNew={(row) => row.push(getDefaultInstitutionalId())}
        onChange={props.onChange}
        renderLines={(iId: InstitutionalId, onChange2: (newValues) => void, actions: Actions, idx: number): ReactNode => {
          return (
            <InputGroup
              delete={{
                action: actions.delete,
                disabled: !props.checkPermission().canWrite,
              }}
            >
              <LabelledDropdown
                id={`institutionId-${idx}-type`}
                autoFocus={props.autoFocus}
                value={iId.institution}
                permissions={props.checkPermission('institution')}
                className={'w-15rem'}
                validation={props.validation?.children[idx]?.fields?.institution}
                options={getVocabularyOptions(intl.locale, props.typesList, props.pubtypeGroup) || []}
                onChange={(institution: any): void => onChange2({ ...iId, institution })}
                label={`${props.title}.attr.institution`}
              />
              <LabelledInputText
                id={`value${idx}`}
                value={iId.value}
                permissions={props.checkPermission('value')}
                validation={props.validation?.children[idx]?.fields?.value}
                onChange={(value: string): void => onChange2({ ...iId, value })}
                label={`${props.title}.attr.value`}
              />
            </InputGroup>
          );
        }}
      />
    </Panel>
  );
}
